import { injectable } from 'inversify';
import { PdfData } from '../entities/PdfData';
import { RESTPdfStorage } from '../repository/RESTPdfStorage';

@injectable()
export class PdfService {
    private pdfStorage = new RESTPdfStorage();

    constructor() {}

    async getPdf(caseID: string, centreCode: string) {
        return await this.pdfStorage.getPdfPerCaseID(caseID, centreCode);
    }

    async savePdf(visitReport: PdfData, caseID: string, headers?: Headers) {
        return await this.pdfStorage.saveCasePdf(visitReport, caseID, headers);
    }

    async cancelPdf(centreCode: string, caseID: string, pdfId: string) {
        return await this.pdfStorage.cancelPdf(centreCode, caseID, pdfId);
    }
}
